import type { FC, ReactElement, ReactNode } from 'react';

import DefaultOnboardingAccent from './components/DefaultOnboardingAccent';
import {
    AccentContainer,
    AccentInner,
    MainContentContainer,
    MainContentOutlet,
    OnboardingContainer,
    OutletContainer,
} from './styles';

type OnboardingBackgroundProps = {
    accent?: ReactElement;
    accentSize?: 'lg' | 'sm';
    children?: ReactNode;
};

const OnboardingBackground: FC<OnboardingBackgroundProps> = ({ accent, accentSize = 'sm', children }) => (
    <OnboardingContainer $largeAccent={accentSize === 'lg'}>
        <MainContentContainer>
            <MainContentOutlet>
                <OutletContainer>{children}</OutletContainer>
            </MainContentOutlet>
        </MainContentContainer>

        <AccentContainer>
            <AccentInner>{accent ?? <DefaultOnboardingAccent />}</AccentInner>
        </AccentContainer>
    </OnboardingContainer>
);

export default OnboardingBackground;
